// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","276":"GuestLazyComponent"}[chunkId] + "." + {"46":"cdfe359527a6ddb3476f","276":"769cf4318955da5e98f0"}[chunkId] + ".js";
};